module.exports = "/_next/static/images/logo-yellow-17d0552923870793a138a26c744139cc.svg";